import { FormControl, FormHelperText, FormLabel, Input } from "@chakra-ui/core";
import React from "react";

function FormInput({
  htmlFor,
  label,
  value,
  handleChange,
  helperText,
  placeholder,
}) {
  return (
    <FormControl>
      <FormLabel htmlFor={htmlFor}>{label}</FormLabel>
      <Input
        placeholder={placeholder}
        type="text"
        id={htmlFor}
        aria-describedby={`${htmlFor}-helper-text`}
      />
      <FormHelperText id={`${htmlFor}-helper-text`}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}

export default FormInput;
